import type { Event } from '@hedepy/common/schemas/modules/event/event'

import CancelSessionDialog from '@/legacy-src/components/calendars/client/multibooking/CancelSessionDialog'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import { useCancellationWindowHours } from '@/src/domains/events/hooks/useCancellationWindowHours'

import { useClientBookingPlannedEvent } from './ClientBookingPlannedEvent.hooks'
import { ClientBookingPlannedEventPopover } from './ClientBookingPlannedEventPopover'
import { ClientBookingPlannedEventRebookWarningDialog } from './ClientBookingPlannedEventRebookWarningDialog'
import { ClientBookingPlannedEventTimeSlot } from './ClientBookingPlannedEventTimeSlot'

export interface ClientBookingPlannedEventProps {
  event: Event
}

export const ClientBookingPlannedEvent = ({ event }: ClientBookingPlannedEventProps) => {
  const {
    isPopoverOpen,
    setPopoverOpen,
    isCancelDialogOpen,
    setCancelDialogOpen,
    isChangeDialogOpen,
    setChangeDialogOpen,
    isChangesDisabled,
    handleChangeEvent,
    handleCancelEvent,
  } = useClientBookingPlannedEvent(event)

  const { t } = getTranslate()
  const { getIsWithinCancellationWindow } = useCancellationWindowHours()

  const canChange = !getIsWithinCancellationWindow(event.startDate)

  const items = [
    ...(canChange
      ? [
          {
            text: t('component.button.changeDate'),
            icon: 'change-rebrand',
            onClick: handleChangeEvent,
          },
        ]
      : []),
    {
      text: t('component.button.cancelSession'),
      icon: 'cancel-rebrand',
      onClick: handleCancelEvent,
    },
  ]

  return (
    <>
      <ClientBookingPlannedEventPopover open={isPopoverOpen} onOpenChange={setPopoverOpen} items={items}>
        <ClientBookingPlannedEventTimeSlot disabled={isChangesDisabled} event={event} />
      </ClientBookingPlannedEventPopover>
      <CancelSessionDialog event={event} open={isCancelDialogOpen} onOpenChange={setCancelDialogOpen} />
      <ClientBookingPlannedEventRebookWarningDialog
        open={isChangeDialogOpen}
        onOpenChange={setChangeDialogOpen}
        onContinue={handleChangeEvent}
      />
    </>
  )
}
